import React, { useEffect, useState, useRef } from 'react';
import { AiOutlineFileText } from "react-icons/ai";
import { MdOutlineQuiz } from "react-icons/md";
import { useFormik, FieldArray, FormikProvider } from 'formik';
import { AddCourseSchema } from './CourseManagementSchema';
import { FaTrash, FaPlus, FaFilePdf, FaImage, FaFileVideo } from 'react-icons/fa';
import { IoInformationCircleOutline } from "react-icons/io5";
import { BiSolidFileDoc, BiSolidFilePng } from "react-icons/bi"
import { BsFiletypeMp4, BsFillFileImageFill } from "react-icons/bs"
import { useDispatch, useSelector } from 'react-redux';
import { addUpdateCourseRes, addUpdateCourseTodo } from '../../LMS_Redux/LMS_Slices/Course/AddUpdateCourse';
import { departmentListTodo } from '../../LMS_Redux/LMS_Slices/Assets/DepartmentList';
import { uploadRes, uploadTodo } from '../../LMS_Redux/LMS_Slices/Assets/UploadImage';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { quizListTodo } from '../../LMS_Redux/LMS_Slices/Quiz/QuizList';
import { folderListTodo } from '../../LMS_Redux/LMS_Slices/FileLibrary/FolderList';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Tooltip } from 'react-tooltip';
import axios from 'axios';
import { courseDetailsRes, courseDetailsTodo } from '../../LMS_Redux/LMS_Slices/Course/CourseDetails';
import { quizMarksListTodo } from '../../LMS_Redux/LMS_Slices/Masters/QuizMarksList';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { updateDraftCourseRes, updateDraftCourseTodo } from '../../LMS_Redux/LMS_Slices/Course/UpdateDraftCourse';
import { Spinner } from 'react-bootstrap';
import { uploadThumbRes, uploadThumbTodo } from '../../LMS_Redux/LMS_Slices/Assets/UploadThumbnailImage';

export default function AddCourse() {

    const selectInputRef_folder = useRef();
    const selectInputRef_department = useRef();
    const selectInputRef_quiz = useRef();

    const { state } = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const departmentList = useSelector(state => state.depratmentList && state.depratmentList.data && state.depratmentList.data.data)
    const quizList = useSelector(state => state.quizList && state.quizList.data && state.quizList.data.data)
    const folderList = useSelector(state => state.folderList && state.folderList.data && state.folderList.data.data)
    const data = useSelector(state => state.courseDetails && state.courseDetails.data && state.courseDetails.data.data && state.courseDetails.data.data[0])
    const quiz_marks = useSelector(state => state.quizMarksList && state.quizMarksList.data && state.quizMarksList.data.data && state.quizMarksList.data.data[0])
    const [loading, setLoading] = useState(false)
    const [formLoading, setFormLoading] = useState(false)
    const [fileList, setFileList] = useState([])
    const [show, setShow] = useState(false)
    const [spinner, setSpinner] = useState(false)

    // console.log(data)

    var options = []
    var content_data = []
    var folder_option = []
    var quiz_option = []

    const dept_list = departmentList && departmentList?.filter(val => val?.vstatus == 'Active')?.map((value) => options.push({
        "value": value.did,
        "label": value.vdepartment_name
    }))

    const [selectedOptions, setSelectedOptions] = useState([]);

    const handleSelectChange = (selected) => {
        let updatedSelectedOptions;

        if (selected && selected?.length && selected[selected?.length - 1].value === 'select-all') {
            // "Select All" option was clicked
            if (selectedOptions?.length === options?.length) {
                updatedSelectedOptions = [];
            } else {
                updatedSelectedOptions = options;
            }
        } else {
            updatedSelectedOptions = selected || [];
        }
        setSelectedOptions(updatedSelectedOptions);
        formik.setFieldValue('department', updatedSelectedOptions);
        dispatch(quizListTodo({ "department": updatedSelectedOptions, "status": 'active', "temp": '' }))
        formik.setFieldValue("quiz_bank", '')
    };

    const customOptions = [{ value: 'select-all', label: 'Select All' }, ...options];

    const fold_opt = folderList && folderList.map((value) => folder_option.push({
        "value": value.id,
        "label": value.folder_name
    }))

    const quiz_opt = quizList && quizList.map((value) => quiz_option.push({
        "value": value.id,
        "label": value.quiz_title
    }))

    const cont_data = state && data && data.lms_course_files.map((value) => content_data.push({
        title: value.content_title,
        source: value.source,
        upload: value.upload_file,
        // library: value.file_library,
        link: value.link,
        file: value.file_path
    }))

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NAME',
            field: 'file_name',
            cellRenderer: (params) =>
                <span>{params.data.file_type == 'jpg' ? <BsFillFileImageFill className='me-2' size={18} /> :
                    params.data.file_type == 'pdf' ? <FaFilePdf className='me-2' size={18} /> :
                        params.data.file_type == 'mp4' ? <FaFileVideo className='me-2' size={18} /> :
                            params.data.file_type == 'png' ? <BiSolidFilePng className='me-2' size={18} />
                                : <BiSolidFileDoc className='me-2' size={18} />}


                    {params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            width: 400,
            checkboxSelection: true,
        },
        {
            headerName: 'SIZE',
            field: 'size',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <a href={process.env.REACT_APP_IMAGE_URL + `${params.data.file_path}`} target='_blank'>
                        <IoInformationCircleOutline size={20} className='eye'
                            // onClick={() => question_details(params)}
                            data-tooltip-id='details'
                            data-tooltip-content="Open File!"
                            data-tooltip-place="bottom"
                        />
                    </a>

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ]);

    const initialValues = {
        course_type: state ? data && data.course_type : '',
        availability: state ? data && data.course_availability : '',
        course_title: state ? data && data.course_title : '',
        course_id: state ? data && data.course_code : '',
        // cover: state ? data && data.cover_image : '',
        thumb: state ? data && data.thumbnail_image : '',
        duration: state ? data && data.duration : '',
        department: state ? data && data.department_data : [],
        min_time: state ? data && data.min_view_time : '',
        course_desc: state ? data && data.course_desc : '',
        content: state ? content_data :
            [
                {
                    title: "",
                    source: "",
                    upload: "",
                    // library: "",
                    link: "",
                    file: ""
                }
            ],
        quiz_bank: state ? data && data.lms_course_quizzes.quiz_id : '',
        max_time: state ? data && data.lms_course_quizzes.max_time_allowed : '',
        max_attempt: state ? data && data.lms_course_quizzes.max_attemps_count : '',
        total_marks: quiz_marks && quiz_marks.total_marks,
        passing_marks: quiz_marks && quiz_marks.passing_marks,
        review: state ? data && data.lms_course_quizzes.participant_allowed : '',
        revise: 1,
        course_unique_id: state ? data && data.id : "",
        revise_reason: state ? state.reason : ''
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: AddCourseSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            if (state && state.draft) {
                dispatch(updateDraftCourseTodo(values)).then(() => update_draft_res(action))
            } else {
                dispatch(addUpdateCourseTodo(values)).then(() => add_update_res(action))
            }

        },
    })

    const update_draft_res = (action) => {
        // console.log(addUpdateCourseRes)
        if (updateDraftCourseRes && updateDraftCourseRes.success) {

            action.resetForm()

            var file_reset = document.querySelectorAll('.file')
            for (var i = 0; i < file_reset.length; i++) {
                file_reset[i].value = '';
            }

            selectInputRef_department.current.setValue([])
            selectInputRef_quiz.current.clearValue()

            toast.success(updateDraftCourseRes.message, { position: "bottom-right" })
            setSpinner(false)
            setTimeout(() => {
                navigate('/course_list')
            }, 1500);

        } else {
            setSpinner(false)
            toast.error(updateDraftCourseRes.message, { position: "bottom-right" })
        }
    }

    const add_update_res = (action) => {
        // console.log(addUpdateCourseRes)
        if (addUpdateCourseRes && addUpdateCourseRes.success) {

            action.resetForm()

            var file_reset = document.querySelectorAll('.file')
            for (var i = 0; i < file_reset.length; i++) {
                file_reset[i].value = '';
            }

            selectInputRef_department.current.setValue([])
            selectInputRef_quiz.current.clearValue()

            toast.success(addUpdateCourseRes?.message, { position: "bottom-right" })
            setSpinner(false)
            setTimeout(() => {
                navigate('/course_list')
            }, 1500);

        } else {
            setSpinner(false)
            toast.error(addUpdateCourseRes?.message, { position: "bottom-right" })
        }
    }

    const uploadThumb = (file) => {
        if (file) {
            dispatch(uploadThumbTodo(file)).then(() => upload_thumb_res())
        }
    }

    const upload_thumb_res = (type, index) => {

        if (uploadThumbRes && uploadThumbRes.success) {

            formik.setFieldValue(`thumb`, uploadThumbRes.data.path)

            toast.success(uploadThumbRes.message, { position: "bottom-right" })
        } else {
            formik.setFieldValue(`thumb`, '')
            toast.error(uploadThumbRes.message, { position: "bottom-right" })
        }
    }

    const uploads = (file, type, index) => {
        if (file) {
            dispatch(uploadTodo(file)).then(() => upload_res(type, index))
        }
    }

    const upload_res = (type, index) => {
        // console.log(uploadRes)
        if (uploadRes && uploadRes.success) {
            if (type == 'cover') {
                // console.log(type)
                formik.setFieldValue(`cover`, uploadRes.data.path)
            } else if (type == 'thumb') {
                // console.log(type)
                formik.setFieldValue(`thumb`, uploadRes.data.path)
            } else if (type == 'content') {
                // console.log(type)
                formik.setFieldValue(index, uploadRes.data.path)
            }
            toast.success(uploadRes.message, { position: "bottom-right" })
        } else {
            toast.error(uploadRes.message, { position: "bottom-right" })
        }
    }

    const reset_val = (index) => {
        formik.setFieldValue(`content[${index}].upload`, '')
        // formik.setFieldValue(`content[${index}].library`, '')
        formik.setFieldValue(`content[${index}].link`, '')
        formik.setFieldValue(`content[${index}].file`, '')
    }

    const files = async (id) => {

        setLoading(true)
        let user_id = JSON.parse(localStorage.getItem('user_data'))
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + "library/view_file_list",
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token },
            data: {
                "user_id": user_id.vemp_code,
                "master_folder_id": id
            },

        }).then(function (response) {
            //handle success
            setFileList(response.data.data)
            setLoading(false)
        })
            .catch(function (response) {
                //handle error
                // console.log(response.data);
                setLoading(false)
            });
    }

    const files_list = (val) => {
        files(val && val.value)
    }

    const reset_modal = () => {
        selectInputRef_folder.current.clearValue()
        setFileList([])
    }

    const details_res = () => {
        if (courseDetailsRes && courseDetailsRes.success) {
            setFormLoading(false)
        } else {
            setFormLoading(false)
        }
    }

    const handleClose = (temp) => {
        // console.log('close', temp)
        if (temp) {
            formik.setFieldValue(`content[${document.getElementById('upinput').value}].file`, '')
            setShow(false)
        } else {
            setShow(false)
        }
    }
    const handleShow = (index) => {
        document.getElementById('upinput').value = index;
        setShow(true)
    }

    // var recipient;

    useEffect(() => {

        // var exampleModal = document.getElementById('exampleModal')
        // exampleModal.addEventListener('shown.bs.modal', function (event) {

        //     var button = event.relatedTarget
        //     recipient = button.getAttribute('data-id')
        //     document.getElementById('upinput').value = recipient;
        //     // document.getElementById('clsbtn').setAttribute('data-id', recipient);

        // })

        // const closeButton = document.querySelector(".close");
        // closeButton.addEventListener("click", () => {
        //     exampleModal.close();
        // });
        // exampleModal.addEventListener('hidden.bs.modal', function (event) {

        //     var button = document.getElementById('clsbtn').getAttribute('data-id')
        //     formik.setFieldValue(`content[${button}].file`, '');
        //     // console.log("T", button);
        //     // recipient = button.getAttribute('data-id')
        //     // alert(recipient);
        //     // document.getElementById('upinput').value = recipient;
        // })

        dispatch(departmentListTodo())
        dispatch(folderListTodo())
        dispatch(quizListTodo({ "department": [], "status": '', "temp": '' }))
        dispatch(quizMarksListTodo({ status: 'active' }))

        if (state) {
            setFormLoading(true)
            dispatch(courseDetailsTodo({ "course_id": state.id, "availability": state.course_availability })).then(() => details_res())
            // console.log("first")
        }
    }, [])


    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    {state ?
                        <Link to={"/course_list"}><span className='icon2'>Learning Module List / </span></Link>
                        : ''
                    }
                    <span className='icon2'>{state ? "Revise" : "Add"} Learning Module</span>
                </div>

                <div className='wrapper-admin'>
                    {formLoading ?

                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>

                        :
                        <FormikProvider value={formik}>
                            <form onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }}>
                                <div className="row">

                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Learning Module Type</label>
                                            <select className="form-select form_input" aria-label="Default select example"
                                                name='course_type'
                                                value={formik.values.course_type || ''}
                                                onChange={(e) => { formik.handleChange(e) }}
                                                onBlur={formik.handleBlur}
                                                disabled={state ? state.draft ? '' : true : ''}
                                            >
                                                <option value=''>Select Type</option>
                                                <option value="general">General</option>
                                                <option value="self-reading">Self Learning</option>
                                            </select>
                                            {formik.errors.course_type && formik.touched.course_type ? (<span className='text-danger form_label'>{formik.errors.course_type}</span>) : null}
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Availability</label>
                                            <select className="form-select form_input" aria-label="Default select example"
                                                name='availability'
                                                value={formik.values.availability || ''}
                                                onChange={(e) => { formik.handleChange(e) }}
                                                onBlur={formik.handleBlur}
                                            >
                                                <option value=''>Select Status</option>
                                                <option value="public">Public</option>
                                                <option value="private">Private</option>
                                                <option value="draft">Draft</option>
                                            </select>
                                            {formik.errors.availability && formik.touched.availability ? (<span className='text-danger form_label'>{formik.errors.availability}</span>) : null}
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Learning Module Title</label>
                                            <input type="text" className="form_input form-control" placeholder="Learning Module Title"
                                                name='course_title' value={formik.values.course_title || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                            />
                                            {formik.errors.course_title && formik.touched.course_title ? (<span className='text-danger form_label'>{formik.errors.course_title}</span>) : null}
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Learning Module ID</label>
                                            <input type="text" className="form_input form-control" placeholder="Learning Module ID"
                                                name='course_id' value={formik.values.course_id || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                                disabled={state ? true : ''}
                                            />
                                            {formik.errors.course_id && formik.touched.course_id ? (<span className='text-danger form_label' >{formik.errors.course_id}</span>) : null}
                                        </div>
                                    </div>

                                    {/* <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Cover Image</label>
                                            <input type="file" className="form_input form-control file" placeholder="Cover Image"
                                                name='cover' onChange={(e) => uploads(e.currentTarget.files[0], "cover", "")} onBlur={formik.handleBlur}
                                            />
                                            {formik.errors.cover && formik.touched.cover ? (<span className='text-danger form_label'>{formik.errors.cover}</span>) : null}
                                        </div>
                                    </div> */}

                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Thumbnail Image</label>
                                            <input type="file" className="form_input form-control file" placeholder="Thumbnail Image" accept=".jpg,.jpeg,.png,.webp"
                                                name='thumb' onChange={(e) => uploadThumb(e.currentTarget.files[0])} onBlur={formik.handleBlur}
                                            />
                                            {/* formik.setFieldValue(`thumb`, e.currentTarget.files[0]) */}
                                            {formik.errors.thumb && formik.touched.thumb ? (<span className='text-danger form_label'> {formik.errors.thumb}</span>) : null}
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-4">
                                        <label htmlFor="" className="form-label form_label">Attempt Learning Module Within</label>
                                        <input type="number" className="form_input form-control" placeholder="Duration (In Days)"
                                            name='duration' value={formik.values.duration || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                        />
                                        {formik.errors.duration && formik.touched.duration ? (<span className='text-danger form_label' > {formik.errors.duration}</span>) : null}
                                    </div>

                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Permission Granted To</label>
                                            <Select
                                                ref={selectInputRef_department}
                                                closeMenuOnSelect={false}
                                                options={customOptions}
                                                // defaultValue={state ? state.department_data : ''}
                                                value={formik.values.department}
                                                onChange={handleSelectChange}
                                                onBlur={formik.handleBlur}
                                                name='department'
                                                isMulti
                                                placeholder="Select Permission To"
                                                classNamePrefix="select"
                                                hideSelectedOptions={true}
                                                allowSelectAll={true}
                                            />
                                            {formik.errors.department && formik.touched.department ? (<span className='text-danger form_label'>{formik.errors.department}</span>) : null}

                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Minimum Viewing Time (In Minutes)</label>
                                            <input type="number" className="form_input form-control" placeholder="Minimum Viewing Time (In Minutes)"
                                                name='min_time' value={formik.values.min_time || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                            />
                                            {formik.errors.min_time && formik.touched.min_time ? (<span className='text-danger form_label'>{formik.errors.min_time}</span>) : null}
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Learning Module Description</label>
                                            <textarea className="form-control form_input" rows="1"
                                                name='course_desc' value={formik.values.course_desc || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                            />
                                            {formik.errors.course_desc && formik.touched.course_desc ? (<span className='text-danger form_label'>{formik.errors.course_desc}</span>) : null}
                                        </div>
                                    </div>

                                </div>

                                <div className='mt-4'>

                                    <FieldArray
                                        name="content"
                                        render={(arrayHelpers) => (
                                            <>
                                                {formik.values.content.map((field, index) => (
                                                    <div className="row" key={index}>
                                                        <div className='col-12 addcourse_heading'>
                                                            <div className='circle'><AiOutlineFileText /></div>
                                                            <h6>Add Resources {index + 1}</h6>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className='float-end'>
                                                                <button type='button' className='btn add_btn me-2' onClick={() => arrayHelpers.push({ title: "", source: "", upload: "", link: "", file: '' })}>
                                                                    <FaPlus size={18} />
                                                                </button>
                                                                {state ?
                                                                    formik.values.content.length !== 1 ?
                                                                        <button type='button' className='btn del_btn' onClick={() => arrayHelpers.remove(index)}>
                                                                            <FaTrash size={18} />
                                                                        </button>
                                                                        :
                                                                        ''
                                                                    :
                                                                    index !== 0 ?
                                                                        <button type='button' className='btn del_btn' onClick={() => arrayHelpers.remove(index)}>
                                                                            <FaTrash size={18} />
                                                                        </button>
                                                                        : ''
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="" className="form-label form_label">Title</label>
                                                                <input type="text" className="form_input form-control" placeholder="Title"
                                                                    name={`content[${index}].title`}
                                                                    value={formik.values.content[index].title}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                                {formik.touched.content && formik.touched.content[index] && formik.touched.content[index].title && formik.errors.content && formik.errors.content[index] && formik.errors.content[index].title ?
                                                                    (<span className='text-danger form_label'> {formik.errors.content[index].title}</span>) : null
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="Source" className="form-label form_label">Source</label>
                                                                <select className="form-select form_input" aria-label="Default select example"
                                                                    name={`content[${index}].source`}
                                                                    value={formik.values.content[index].source}
                                                                    onChange={(e) => { formik.handleChange(e); reset_val(index) }}
                                                                    onBlur={formik.handleBlur}
                                                                >
                                                                    <option value=''>Select Source</option>
                                                                    <option value="upload">Upload</option>
                                                                    <option value="link">External Link</option>
                                                                    <option value="youtube">YouTube</option>
                                                                    <option value="vimeo">Vimeo</option>
                                                                    <option value="library">Library</option>
                                                                </select>
                                                                {formik.touched.content && formik.touched.content[index] && formik.touched.content[index].source && formik.errors.content && formik.errors.content[index] && formik.errors.content[index].source ?
                                                                    (<span className='text-danger form_label'> {formik.errors.content[index].source}</span>) : null
                                                                }
                                                            </div>
                                                        </div>

                                                        {formik.values.content[index].source == "upload" ?
                                                            <div className="col-12 col-md-4">
                                                                <div className="mb-3">
                                                                    <label htmlFor="UploadFile" className="form-label form_label file">Upload file</label>
                                                                    <input type="file" className="form_input form-control" id="UploadFile" placeholder="Upload file"
                                                                        name={`content[${index}].upload`}
                                                                        onChange={(e) => uploads(e.currentTarget.files[0], "content", `content[${index}].upload`)}
                                                                        // onChange={(e) => formik.setFieldValue(`content[${index}].upload`, e.currentTarget.files[0])}
                                                                        onBlur={formik.handleBlur}
                                                                    />
                                                                    {formik.touched.content && formik.touched.content[index] && formik.touched.content[index].upload && formik.errors.content && formik.errors.content[index] && formik.errors.content[index].upload ?
                                                                        (<span className='text-danger form_label'> {formik.errors.content[index].upload}</span>) : null
                                                                    }
                                                                </div>
                                                            </div>
                                                            : ''
                                                        }

                                                        {formik.values.content[index].source == "library" ?

                                                            formik.values.content[index] && formik.values.content[index].file ?

                                                                <div className="col-12 col-md-4">
                                                                    <div className="mb-3">
                                                                        {/* <label htmlFor="" className="form-label form_label">Selected File</label> <br /> */}
                                                                        <span className='d-flex justify-content-between align-items-center' style={{ marginTop: '30px' }}>
                                                                            {/* <span>{formik.values.content[index] && formik.values.content[index].file}</span> */}

                                                                            <a href={process.env.REACT_APP_IMAGE_URL + formik.values.content[index].file} target='blank' className='btn btn_submit d-flex align-items-center'><IoInformationCircleOutline className='me-1' />View File</a>

                                                                            <span onClick={() => formik.setFieldValue(`content[${index}].file`, '')} className='delete'><FaTrash /></span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="col-12 col-md-4">
                                                                    <div style={{ marginTop: '30px' }}>
                                                                        <button className='btn btn_submit d-flex align-items-center' onClick={() => handleShow(index)}><FaPlus className='me-1' />Add File {index + 1}</button>
                                                                        {/* <button className='btn btn_submit d-flex align-items-center' data-id={index} type="button" data-bs-toggle="modal" data-bs-target="#exampleModal"><FaPlus className='me-1' />Add File {index + 1}</button> */}

                                                                    </div>
                                                                    {formik.touched.content && formik.touched.content[index] && formik.touched.content[index].file && formik.errors.content && formik.errors.content[index] && formik.errors.content[index].file ?
                                                                        (<span className='text-danger form_label'> {formik.errors.content[index].file}</span>) : null
                                                                    }
                                                                </div>
                                                            : ''
                                                        }

                                                        {formik.values.content[index].source == "link" || formik.values.content[index].source == "youtube" || formik.values.content[index].source == "vimeo" ?
                                                            <div className="col-12 col-md-4">
                                                                <div className="mb-3">
                                                                    <label htmlFor="" className="form-label form_label">External Link</label>
                                                                    <input type="text" className="form_input form-control" placeholder="Link"
                                                                        name={`content[${index}].link`}
                                                                        value={formik.values.content[index].link}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                    />
                                                                    {formik.values.content[index].source == "youtube" ? <span style={{ fontSize: '9px' }}>https://www.youtube.com/embed/<span className='text-danger'>VAaUy_Moivw</span></span> : ''} <br />
                                                                    {formik.touched.content && formik.touched.content[index] && formik.touched.content[index].link && formik.errors.content && formik.errors.content[index] && formik.errors.content[index].link ?
                                                                        (<span className='text-danger form_label'> {formik.errors.content[index].link}</span>) : null
                                                                    }
                                                                </div>
                                                            </div>

                                                            : ''
                                                        }

                                                    </div>
                                                ))}
                                            </>
                                        )}
                                    />
                                </div>

                                <div className='mt-4'>
                                    <div className="row">

                                        <div className='col-12 addcourse_heading'>
                                            <div className='circle'><MdOutlineQuiz /></div>
                                            <h6>Add Exam</h6>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Quiz Bank</label>
                                                <Select
                                                    ref={selectInputRef_quiz}
                                                    closeMenuOnSelect={true}
                                                    options={quiz_option}
                                                    defaultValue={state ? data && quiz_option.find((option) => option.value == data.lms_course_quizzes.quiz_id) : ''}
                                                    onChange={(e) =>
                                                        // console.log(e)
                                                        formik.setFieldValue('quiz_bank', e && e.value || '')
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    name='quiz_bank'
                                                    // isMulti
                                                    placeholder="Select Quiz"
                                                    classNamePrefix="select"
                                                />

                                                {formik.errors.quiz_bank && formik.touched.quiz_bank ? (<span className='text-danger form_label'>{formik.errors.quiz_bank}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Max Time Allowed</label>
                                                <input type="number" className="form_input form-control" placeholder="Max time allowed"
                                                    name='max_time' value={formik.values.max_time || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                                />
                                                {formik.errors.max_time && formik.touched.max_time ? (<span className='text-danger form_label'>{formik.errors.max_time}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Max No. of Attempts</label>
                                                <input type="number" className="form_input form-control" placeholder="Max No. of attempts"
                                                    name='max_attempt' value={formik.values.max_attempt || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                                />
                                                {formik.errors.max_attempt && formik.touched.max_attempt ? (<span className='text-danger form_label'>{formik.errors.max_attempt}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Total Marks</label>
                                                <input type="number" className="form_input form-control" placeholder="Total Marks"
                                                    name='total_marks' value={formik.values.total_marks || ''} onChange={formik.handleChange} onBlur={formik.handleBlur} readOnly={true}
                                                />
                                                {formik.errors.total_marks && formik.touched.total_marks ? (<span className='text-danger form_label' > {formik.errors.total_marks}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Passing Marks</label>
                                                <input type="number" className="form_input form-control" placeholder="Passing Marks"
                                                    name='passing_marks' value={formik.values.passing_marks || ''} onChange={formik.handleChange} onBlur={formik.handleBlur} readOnly={true}
                                                />
                                                {formik.errors.passing_marks && formik.touched.passing_marks ? (<span className='text-danger form_label'>{formik.errors.passing_marks}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="AllowParticipant" className="form-label form_label">Allow Participant to Review </label>
                                                <select className="form-select form_input" aria-label="Default select example"
                                                    name='review' value={formik.values.review || ''} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                                >
                                                    <option value=''>Select</option>
                                                    <option value="passes">If Passes</option>
                                                    <option value="never">Never</option>
                                                    <option value="always">Always</option>
                                                </select>
                                                {formik.errors.review && formik.touched.review ? (<span className='text-danger form_label'>{formik.errors.review}</span>) : null}
                                            </div>
                                        </div>

                                        <div className='text-end mt-4'>
                                            <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                                {spinner ?
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        className='ms-2'
                                                    />
                                                    : ''
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </FormikProvider>
                    }

                    <input type='hidden' id='upinput' />
                    <Modal show={show} onHide={handleClose} centered size="xl" backdrop="static" >
                        <Modal.Header>
                            <Modal.Title>Select File</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-4 mb-4">
                                    <label htmlFor="Library" className="form-label form_label">Folder List</label>
                                    <Select
                                        ref={selectInputRef_folder}
                                        closeMenuOnSelect={true}
                                        options={folder_option}
                                        // defaultValue={state ? state.department_data : ''}
                                        onChange={(e) =>
                                            files_list(e)
                                        }
                                        // onBlur={formik.handleBlur}
                                        name='library'
                                        // isMulti
                                        placeholder="Select Folder"
                                        classNamePrefix="select"
                                    />
                                </div>

                                <div className="col-md-12">

                                    {loading ?
                                        <div className='wrapper-admin'>
                                            <div className='text-center mb-3'>
                                                <PropagateLoader
                                                    color="#2262C6"
                                                    size={20}
                                                />
                                            </div>
                                        </div>
                                        :
                                        fileList && fileList.length ?
                                            <DataTables
                                                rowData={fileList}
                                                columnDefs={columnDefs}
                                                height={'40vh'}
                                                selection={true}
                                                value={formik.setFieldValue}
                                                check={"single"}
                                                filterData={true}
                                                addCourseModal={true}
                                            />
                                            :
                                            <div className='wrapper-admin'>
                                                <div className='text-center'>
                                                    Files Not Found
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => { handleClose(true); reset_modal() }}>
                                Close
                            </Button>
                            <Button variant="primary" onClick={() => { handleClose(false); reset_modal() }} disabled={formik.values.content[document.getElementById('upinput') && document.getElementById('upinput').value] && formik.values.content[document.getElementById('upinput') && document.getElementById('upinput').value].file ? '' : true}>
                                Submit
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
                        <div className="modal-dialog modal-dialog-centered modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5" id="exampleModalLabel">Select File</h1>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => reset_modal()}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-4 mb-4">
                                            <label htmlFor="Library" className="form-label form_label">Folder List</label>
                                            <Select
                                                ref={selectInputRef_folder}
                                                closeMenuOnSelect={true}
                                                options={folder_option}
                                                // defaultValue={state ? state.department_data : ''}
                                                onChange={(e) =>
                                                    files_list(e)
                                                }
                                                // onBlur={formik.handleBlur}
                                                name='library'
                                                // isMulti
                                                placeholder="Select Folder"
                                                classNamePrefix="select"
                                            />
                                        </div>

                                        <input type='hidden' id='upinput' />

                                        <div className="col-md-12">

                                            {loading ?
                                                <div className='wrapper-admin'>
                                                    <div className='text-center mb-3'>
                                                        <PropagateLoader
                                                            color="#2262C6"
                                                            size={20}
                                                        />
                                                    </div>
                                                </div>
                                                :
                                                fileList && fileList.length ?
                                                    <DataTables
                                                        rowData={fileList}
                                                        columnDefs={columnDefs}
                                                        height={'40vh'}
                                                        selection={true}
                                                        value={formik.setFieldValue}
                                                        check={"single"}
                                                        filterData={true}
                                                        addCourseModal={true}
                                                    />
                                                    :
                                                    <div className='wrapper-admin'>
                                                        <div className='text-center'>
                                                            Files Not Found
                                                        </div>
                                                    </div>

                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" id='clsbtn' data-bs-dismiss="modal" onClick={() => reset_modal()}>Close</button>
                                    <button type="button" className="btn btn-primary close">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>

            </div >
            <ToastContainer />
        </>
    )
}